import { atom } from "recoil";

export const contentKeyState = atom<string>({
  key: "contentKey",
  default: "",
});
